export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  supervisor: 'Supervisor',
  approver: 'Approver',
  requestor: 'Requestor',
  operator: 'Operator',
};

export const STATUS_LABELS = {
  operational: 'Operational',
  breakdown: 'Breakdown',
  idle: 'Idle',
  inefficient: 'Inefficient',
  scrap: 'Scrap',
  for_disposal: 'For Disposal',
  maintenance: 'Maintenance',
  reserved: 'Reserved',
};

export const STATUS_COLORS = {
  operational: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  breakdown: 'bg-red-100 text-red-800 border-red-200',
  idle: 'bg-slate-100 text-slate-700 border-slate-200',
  inefficient: 'bg-amber-100 text-amber-800 border-amber-200',
  scrap: 'bg-zinc-200 text-zinc-700 border-zinc-300',
  for_disposal: 'bg-orange-100 text-orange-800 border-orange-200',
  maintenance: 'bg-sky-100 text-sky-800 border-sky-200',
  reserved: 'bg-violet-100 text-violet-800 border-violet-200',
};

export const REQUEST_STATUS_COLORS = {
  pending: 'bg-amber-100 text-amber-800 border-amber-200',
  approved: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  rejected: 'bg-red-100 text-red-800 border-red-200',
  deployed: 'bg-sky-100 text-sky-800 border-sky-200',
  completed: 'bg-slate-200 text-slate-800 border-slate-300',
  archived: 'bg-zinc-100 text-zinc-600 border-zinc-200',
};

// Backend stores timestamps as naive UTC ISO strings (e.g. "2026-02-10T07:30:00").
// We append 'Z' so JavaScript parses them as UTC (otherwise they'd be treated as
// local time) and then render in Asia/Manila (GMT+8) ? the canonical timezone
// for this PIVI ESD deployment.
const TZ = 'Asia/Manila';
const _toUtcDate = (s) => {
  if (s instanceof Date) return s;
  const str = String(s);
  // Already carries a timezone designator? leave it alone.
  const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(str);
  return new Date(hasTz ? str : str + 'Z');
};

export const formatDate = (s) => {
  if (!s) return '—';
  try {
    const d = _toUtcDate(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString('en-PH', { year: 'numeric', month: 'short', day: '2-digit', timeZone: TZ });
  } catch {
    return s;
  }
};

export const formatDateTime = (s) => {
  if (!s) return '—';
  try {
    const d = _toUtcDate(s);
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleString('en-PH', { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: TZ });
  } catch {
    return s;
  }
};

export const formatCurrency = (n) =>
  new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP', maximumFractionDigits: 2 }).format(n || 0);

export const formatNumber = (n) => new Intl.NumberFormat('en-PH').format(n || 0);
